(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/template.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/template.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.views.Template = Backbone.View.extend(
    {
      defaults: {
        template: svs.tipset.templates.template,

        templateName: 'svs.tipset.views.Template (name not defined)'
      },

      initialize: function() {},

      render: function() {
        svs.tipset.calls.addCall(this.options.templateName);
        this.$el.html(this.options.template());

        return this;
      },

      onDestroy: function() {
        this.$el.empty();
      }
    },
    {
      type: 'svs.tipset.views.Template'
    }
  );
})(Backbone, _, svs);

 })(window);